// import { $Tawk } from "vue-tawk";
import store, { limparDadosBasicos, limparTodosOsDados } from "@/store";
import { $loaderService } from "@/plugins/ELoaderService";
import router from "@/router";
import User from "@/Models/User";
import Axios from "../plugins/Axios";
import constants from "../plugins/constants";

export class AuthService {
  static ACCESS_TOKEN_NAME = "access_token";

  static rolesQuePodemTrocarAno = [
    {
      id: "1",
      name: "admin",
      can: true,
    },
    {
      id: "2",
      name: "professor",
      can: true,
    },
    {
      id: "3",
      name: "aluno",
      can: false,
    },
    {
      id: "4",
      name: "secretario",
      can: true,
    },
    {
      id: "5",
      name: "coordenador",
      can: true,
    },
    {
      id: "6",
      name: "super-admin",
      can: true,
    },
    {
      id: "7",
      name: "direção",
      can: true,
    },
    {
      id: "8",
      name: "supervisor",
      can: false,
    },
    {
      id: "9",
      name: "tec-admin",
      can: false,
    },
  ];

  async logar({ email, password }) {
    await Axios().get("/sanctum/csrf-cookie");
    const response = await Axios().post("/login", {
      email,
      password,
      device_name: this.getDeviceName(),
    });

    // $Tawk.$showWidget();
    this.setAccessToken(response.data);
    $loaderService.loadBasicDataIfNeeded();
    // if (window.Tawk_API.showWidget) window.Tawk_API.showWidget();
    this.syncUserWithStore();

    this.verificarForcaDaSenha();
    store.dispatch("Auth/verificarForcaDaSenha");
  }

  async verificarForcaDaSenha() {
    await Axios().get("/verificar-forca-da-senha");
  }

  async getCurrentUser() {
    const response = await Axios().get("/current-user");
    return new User(response.data);
  }

  getDeviceName() {
    return `${navigator.appCodeName} - ${navigator.platform}`;
  }

  async logout() {
    // await Axios().get("/logout");
    store.commit("Auth/setUser", null);
    limparTodosOsDados();
    localStorage.removeItem(AuthService.ACCESS_TOKEN_NAME);
    $loaderService.close();
    // if (window.Tawk_API.hideWidget) window.Tawk_API.hideWidget();
  }

  setAccessToken(accessTokenObject) {
    localStorage.setItem(AuthService.ACCESS_TOKEN_NAME, accessTokenObject.access_token);
  }

  async syncUserWithStore() {
    if (this.isLoggedIn()) {
      const user = await this.getCurrentUser();

      // if (user) {
      //   try {
      //     const { data: hash } = await Axios().get("tawk-to-hash", {
      //       params: { email: user.email },
      //     });
      //     const tawkToUser = {
      //       name: user.name,
      //       email: user.email,
      //       hash,
      //     };
      //     $Tawk.$setAttributes(tawkToUser);
      //   } catch (error) {
      //     // eslint-disable-next-line
      //     return;
      //   }
      // }
      store.commit("Auth/setUser", user);
    }
  }

  isLoggedIn() {
    return Boolean(this.getAccessToken());
  }

  getAccessToken() {
    try {
      return localStorage.getItem(AuthService.ACCESS_TOKEN_NAME);
    } catch (error) {
      return error;
    }
  }

  async updateCurrentUser(user) {
    const currentUser = store.getters["Auth/user"];
    if (!currentUser || !user) throw new Error("Usuário inexistente");
    const response = await Axios().put(`/users/me`, user);
    const updatedUser = response.data;
    await this.syncUserWithStore();
    // store.commit("Auth/setUser", updatedUser);
    return updatedUser;
  }

  async mudarDeAno(ano) {
    if (!ano) throw new Error("Ano escolhido inválido");
    const currentUser = store.getters["Auth/user"];
    if (
      AuthService.rolesQuePodemTrocarAno
        .filter((role) => role.can)
        .map((role) => role.name)
        .includes(currentUser.roleName)
    ) {
      await this.updateCurrentUser({ ...currentUser, ano_id: ano.id });
      window.location.reload();
      router.push({ path: "/" });
      return;
    }

    throw new Error("Permissao somente para super-administradores");
  }

  async mudarDeFranquia(franquia) {
    if (!franquia) throw new Error("Franquia escolhida é inválida");
    const currentUser = store.getters["Auth/user"];
    await this.updateCurrentUser({ ...currentUser, configuracao_id: franquia.id });
    limparDadosBasicos();
    router.push({ path: "/" });
  }

  async atualizarSenha(password) {
    await Axios().put("/update-password", { password });
    store.dispatch("Auth/verificarForcaDaSenha");
  }
}

export default new AuthService();
